import { ErrorResponse, GetReserveTripsReportRequest } from "../../api";
import { ReserveTripsReportRow } from "../../api/models/ReserveTripsReportRow";
import { ReserveTripsRequest } from "../../api/models/ReserveTripsRequest";
import { newDisplayCond } from "../../components/table/sortableTable";
import {
    ReserveTripsState,
    reserveTripsSlice,
} from "../../features/Reserve/store";
import { commonSlice, store } from "../../store";
import { getDriverById } from "../common/drivers";
import { api } from "../common/make_api";
import {
    ActionType,
    ResourceType,
    StatusType,
    sendLog,
} from "../common/send_log";
import { Logout } from "../login/login";

export async function resetTripReports(): Promise<any> {
    store.dispatch(reserveTripsSlice.actions.update_trips(null));
}

const resetTripState = () => {
    const newTripSelection: ReserveTripsState = {
        driverId: -1000,
        driverCode: "",
        driverName: "",
        shiftDate: "",
        shiftMin: "",
        naviUsageRate: -1,
        needGuidanceHermesHeader: "",
        displayCond: newDisplayCond("unladen_start_time", "asc", 0, 20),
    };

    store.dispatch(
        reserveTripsSlice.actions.update_selection_state(newTripSelection)
    );
};

export async function selectTripsReport(
    shiftId: string,
    officeId: number,
    needGuidanceHeader?: string,
    driverCode?: string,
    naviUsageRate?: number
): Promise<any> {
    store.dispatch(commonSlice.actions.startLoading());
    try {
        resetTripState();
        const tripsRequest: ReserveTripsRequest = {
            shiftId: shiftId,
            officeId: officeId,
        };
        const req_trips: GetReserveTripsReportRequest = {
            reserveTripsRequest: tripsRequest,
        };

        const res_trips = await api
            .getReserveApi()
            .getReserveTripsReport(req_trips);

        sendLog(
            ResourceType.SHIFTS_MONITORING,
            StatusType.GET_RESOURCE,
            ActionType.SELECT_TRIPS_REPORTS,
            {
                action_type: ActionType.SELECT_TRIPS_REPORTS.toString(),
                shift_id: shiftId,
                driver_code: driverCode,
                office_id: officeId,
            }
        );

        if (res_trips.trips && res_trips.trips[0]) {
            const rec: ReserveTripsReportRow = res_trips.trips[0];

            let naviUsage = -1;
            // if null or undefined or other falsy value, leave as -1; 0 is only if rate actually equals 0
            if (naviUsageRate == 0) {
                naviUsage = 0;
            } else {
                if (naviUsageRate) {
                    naviUsage = naviUsageRate;
                }
            }

            const elmt = getDriverById(rec.driverId, rec.officeId);

            const newTripSelection: ReserveTripsState = {
                driverId: rec.driverId ? rec.driverId : -1000,
                driverCode: driverCode ? driverCode : "-",
                driverName: elmt ? elmt.driverName : "",
                shiftDate: rec.shiftDate ? rec.shiftDate.toString() : "111",
                shiftMin: rec.shiftLenMin ? rec.shiftLenMin.toString() : "111",
                naviUsageRate: naviUsage,
                needGuidanceHermesHeader: needGuidanceHeader
                    ? needGuidanceHeader
                    : "",
                displayCond: newDisplayCond("unladen_start_time", "asc", 0, 20),
            };

            store.dispatch(
                reserveTripsSlice.actions.update_selection_state(
                    newTripSelection
                )
            );
        }

        store.dispatch(commonSlice.actions.updateSelectedOffice(officeId));

        store.dispatch(reserveTripsSlice.actions.update_trips(res_trips.trips));

        return res_trips;
    } catch (err) {
        console.log("Got this error from trip_reports:", err);
        if (err["status"] == 401) {
            console.log("Session has expired");
            Logout();
            return;
        }

        if (err.message) {
            store.dispatch(
                commonSlice.actions.setErrorMessage([err.message as string])
            );
            await store.dispatch(commonSlice.actions.showServerErrorMessage());

            return;
        }
        if (err.status && err.status == 500) {
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }
        const res = (await (err as Response).json()) as ErrorResponse;
        store.dispatch(commonSlice.actions.setErrorMessage([res.message!]));
    } finally {
        store.dispatch(commonSlice.actions.finishLoading());
    }
}
